
import React from 'react';

export default function About() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-center mb-8">About OGMAI</h1>
      
      <div className="max-w-3xl mx-auto space-y-8">
        <section className="prose lg:prose-lg">
          <h2 className="text-2xl font-semibold mb-4">Our Vision</h2>
          <p className="text-gray-600 mb-6">
            At OGMAI, we are pioneering the future of AI agent marketplaces, creating a platform where innovation meets practicality. Our mission is to democratize access to advanced AI technologies, making them accessible and useful for businesses and individuals alike.
          </p>
        </section>

        <section className="prose lg:prose-lg">
          <h2 className="text-2xl font-semibold mb-4">What We Do</h2>
          <p className="text-gray-600 mb-6">
            We provide a robust marketplace where creators can develop and share AI agents, while users can discover and implement these solutions to enhance their productivity and capabilities.
          </p>
        </section>

        <section className="prose lg:prose-lg">
          <h2 className="text-2xl font-semibold mb-4">Our Values</h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-3">
            <li>Innovation: Pushing the boundaries of what's possible with AI</li>
            <li>Quality: Ensuring high standards for all agents on our platform</li>
            <li>Security: Protecting our users' data and privacy</li>
            <li>Community: Fostering collaboration between creators and users</li>
          </ul>
        </section>

        <section className="prose lg:prose-lg">
          <h2 className="text-2xl font-semibold mb-4">Join Us</h2>
          <p className="text-gray-600">
            Whether you're an AI developer looking to share your innovations or a business seeking powerful AI solutions, OGMAI is your platform. Join us in shaping the future of AI automation and discovery.
          </p>
        </section>
      </div>
    </div>
  );
}
